import { Box } from '@chakra-ui/react';

import useGetStockList from 'Domain/stock-promo/useGetStockList';
import useGetPromoList from 'Domain/stock-promo/useGetPromoList';

import Head from 'View/stock-promo/section/head';
import Tab from 'View/stock-promo/section/tab';
import Filter from 'View/stock-promo/section/filter';
import Table from 'View/stock-promo/section/table';
import StockPromoProvider, { useStockPromoState } from 'View/stock-promo/state';

import styles from './styles.module.css';

const StockPromo = () => {
  const { selectedTab, filterState } = useStockPromoState();

  const { data: dataStock, isFetching: isFetchingStock } = useGetStockList({ enabled: selectedTab === 'stock', params: filterState });
  const { data: dataPromo, isFetching: isFetchingPromo } = useGetPromoList({ enabled: selectedTab === 'promo', params: filterState });

  const data = selectedTab === 'stock' ? dataStock : dataPromo;
  const isFetching = selectedTab === 'stock' ? isFetchingStock : isFetchingPromo;

  return (
    <Box className={styles['stock-promo__container']}>
      <Head />
      <Tab />
      <Filter data={data} isFetching={isFetching} />
      <Table data={data} isFetching={isFetching} />
    </Box>
  );
};

const StockPromoContainer = (props) => <StockPromoProvider children={<StockPromo {...props} />} />;

export default StockPromoContainer;
